import { z } from "zod";
import { FormControl } from "@/models/form-types";
import { createCheckboxControl, createRadioControl } from "@/helpers/utils/utility-functions";
import { ERROR_MESSAGES } from "@/helpers/utils/form-constants";

// Asked of everyone C-Tribe would feature in a lineup (speakers, designers,
// models, artists, pitch finalists). Gives the programming team an early,
// self-reported gauge of each applicant's draw for booking and promotion.
export const audienceReachOptions = ["0-10", "11-25", "26-50", "51-100", "101-250", "250+"] as const;
export const audienceChannelOptions = [
  "Instagram", "TikTok", "LinkedIn", "X / Twitter", "YouTube",
  "Email list or newsletter", "Community groups or organisations", "Press or media", "Other",
] as const;

export const audienceReachControls: Record<string, FormControl> = {
  expectedTicketReach: createRadioControl(
    "If we feature you in the lineup, roughly how many people in your circle do you think would buy a ticket to see you?",
    audienceReachOptions,
    "Friends, fans, followers, colleagues, or community members. A best guess is perfect."
  ),
  audienceChannels: createCheckboxControl(
    "How would you let your audience know?",
    audienceChannelOptions,
    "Select all that apply.",
    true
  ),
};

export const audienceReachSchema = {
  expectedTicketReach: z.enum(audienceReachOptions, { required_error: ERROR_MESSAGES.SelectOne() }),
  audienceChannels: z.array(z.enum(audienceChannelOptions)).max(audienceChannelOptions.length).optional(),
};

// Insert before the terms step so the applicant still finishes on consent.
export function withAudienceReach<T>(fields: Record<string, T>, extra: Record<string, T>): Record<string, T> {
  const entries = Object.entries(fields);
  const termsIndex = entries.findIndex(([key]) => key === "acceptTerms" || key.endsWith("Consent"));
  const at = termsIndex === -1 ? entries.length : termsIndex;
  return Object.fromEntries([...entries.slice(0, at), ...Object.entries(extra), ...entries.slice(at)]);
}
